var exports = {
  "k": "dialogFooter__Q4Z9gE",
  "S2": "dialogFooterStatus__qcvjsb",
  "dc": "dialogFooterActions__dusSYQ",
  "Mz": "loadingIndicator__8_P5Or",
};

module.exports = exports;
